import Decimal from 'decimal.js-light';
import { IWorkOrderLineEntity } from '@phrospr/lib-models';

// Fraction values, matching the quote domain conventions (0.06 = 6%). One VAT
// rate per work order (data.vat_percentage), like quote.data.btw_percentage.
export const WORK_ORDER_VAT_PERCENTAGES = [0, 0.06, 0.21];

export function isValidVatPercentage(vatPercentage: number | null | undefined): boolean {
    return vatPercentage == null || WORK_ORDER_VAT_PERCENTAGES.includes(vatPercentage);
}

export function lineHasPricing(line: IWorkOrderLineEntity): boolean {
    return line.unit_price !== null && line.unit_price !== undefined;
}

// Recomputes final_price_to_pay on every priced line (mutates, like the quote
// engine). Lines without a unit price stay unpriced.
export function fillWorkOrderLinePrices(workOrderLines: IWorkOrderLineEntity[]): void {
    for (const line of workOrderLines) {
        if (!lineHasPricing(line)) {
            line.final_price_to_pay = null;
            continue;
        }
        line.final_price_to_pay = calculateWorkOrderLinePrice(line);
    }
}

export function calculateWorkOrderLinePrice(line: IWorkOrderLineEntity): number {
    return new Decimal(line.quantity).times(line.unit_price).toDecimalPlaces(2, Decimal.ROUND_HALF_UP).toNumber();
}

// Totals over the priced lines: one vat_percentage (fraction) applied to the
// subtotal, like calculateQuotePrices. Missing rate means untaxed (0).
export function calculateWorkOrderTotals(
    workOrderLines: IWorkOrderLineEntity[] | undefined,
    vatPercentage?: number | null,
): {
    subTotal: number;
    vatAmount: number;
    totalInclVat: number;
} {
    let subTotal = new Decimal(0);
    for (const line of workOrderLines ?? []) {
        if (!lineHasPricing(line)) continue;
        subTotal = subTotal.plus(calculateWorkOrderLinePrice(line));
    }
    subTotal = subTotal.toDecimalPlaces(2, Decimal.ROUND_HALF_UP);
    const vatAmount = subTotal.times(vatPercentage ?? 0).toDecimalPlaces(2, Decimal.ROUND_HALF_UP);
    return {
        subTotal: subTotal.toNumber(),
        vatAmount: vatAmount.toNumber(),
        totalInclVat: subTotal.plus(vatAmount).toDecimalPlaces(2, Decimal.ROUND_HALF_UP).toNumber(),
    };
}
